<template>
    <section class="p-5 card log-panel col-md-4 offset-md-4 col-10 offset-1 mt-md-0 mt-1">
        <h5 class="text-center">تقرير حركة المستخدم</h5>
        <form @submit.prevent="getReport" class=" my-3">
            <div class="mb-3">
                <label for="from" class="form-label">من : </label>
                <input type="date" v-model="searchData.from" id="from" class="form-control" placeholder=""
                    aria-describedby="from-date" />
                <!-- <small id="from-date" class="text-muted">من تاريخ</small> -->
            </div>
            <div class="mb-3">
                <label for="to" class="form-label">إلى : </label>
                <input type="date" v-model="searchData.to" id="to" class="form-control" placeholder=""
                    aria-describedby="to-date" />
                <!-- <small id="to-date" class="text-muted">إلى تاريخ</small> -->
            </div>
            <div class="d-flex justify-content-between mt-2">
                <button class="btn btn-primary " type="submit">بحث</button>
                <button @click="$router.go(-1)" class="btn btn-secondary " type="button">عودة
                    <font-awesome-icon icon="fa-regular fa-circle-left" />
                </button>
            </div>
        </form>
    </section>


    <section v-if="reportData.length > 0" class="p-5 card log-panel col-xl-8 offset-xl-2 col-10 offset-1 my-3">
        <div class="row">
            <div v-for="(reportAppSection, index) in reportData" :key="index" class="table-responsive">
                <h2 class="text-center label my-3">{{reportAppSection.userName}} ({{departs.find(e => e.id ===
                    reportAppSection.departId)?.name}})</h2>
                <table v-if="reportAppSection?.report.length" class="main-table table table-bordered">
                    <thead>
                        <tr>
                            <th>ر.ت</th>
                            <th>الحركة</th>
                            <th>المستهدف</th>
                            <th>وصف المستهدف</th>
                            <th>تاريخ النشاط</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(activityReport, i) in reportAppSection.report" :key="i" class="bg-blink">
                            <td>{{ (searchData.pageSize * (searchData.pageNo - 1)) + i + 1}}</td>
                            <td>{{ activityReport.activityName }}</td>
                            <td>{{ activityReport.targetType }}</td>
                            <td>{{ activityReport.targetName }}</td>
                            <td>{{ activityReport.activityDate }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="text-center">
                    <h3>
                        <p class="text-muted">لا توجد نتائج مطابقة.</p>
                    </h3>
                </div>

                <!-- Pagination Controls for each table -->
                <div class="pagination-controls text-center mt-3">
                    <button class="btn btn-primary" :disabled="reportAppSection.pageNo === 1"
                        @click="changePage(reportAppSection, reportAppSection.pageNo - 1)">
                        السابق
                    </button>
                    <span class="mx-2">الصفحة {{ reportAppSection.pageNo }} من {{ reportAppSection.totalPages }}</span>
                    <button class="btn btn-primary" :disabled="reportAppSection.pageNo === reportAppSection.totalPages"
                        @click="changePage(reportAppSection, reportAppSection.pageNo + 1)">
                        التالي
                    </button>
                    <span class="mx-3" title="العدد الإجمالي">{{ (currentCountInView < reportData[0]?.totalResults) ?
                            currentCountInView : reportData[0]?.totalResults }} من {{ reportData[0]?.totalResults
                            }}</span>
                </div>
                <!--  -->
                <div class="d-flex justify-content-between">
                    <button class="btn btn-primary align-end" @click="printPdf()">طباعة التقرير <font-awesome-icon
                            :icon="['fas', 'print']" /></button>
                    <div class="d-flex">

                    </div>
                </div>
                <hr />
            </div>
        </div>
    </section>
</template>

<script>
import GeneralModal from "@/components/Modal.vue";
import AlertModal from "@/components/AlertModal.vue";
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "illegalsReport",
    components: {
        GeneralModal,
        AlertModal
    },
    data() {
        return {
            searchData: {
                from: null,
                to: null,
                userId: this.$route.params?.userId,
                pageNo: 1,
                pageSize: 25,
            },
            targetTypes: {
                applicant: "طلب",
                user: "مستخدم",
                setting: "إعداد",
                cities: "مدينة"
            },
            departs: [],
            reportData: [],
        }
    },
    async created() {
        this.setDates();
        await this.fetchOptions();
        await this.getReport();

    },
    computed: {
        ...mapGetters(['getUser', 'getDeparts']),
        currentCountInView : function(){
            return this.searchData?.pageSize * this.searchData?.pageNo;
        }
    },
    methods: {
        /** */
        ...mapActions([
            'fetchUser',
            'fetchDeparts'
        ]),
        /********************************/
         /* */
        setDates(){
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            const day = currentDate.getDate();
            const monthAgoDate = new Date(year, month - 1 , day + 1);
            // If the day rolled over to the next month (e.g., Feb 31 becomes Mar 2), fix it
            if(monthAgoDate.getMonth() === month) {
                monthAgoDate.setDate(1);
            }
            this.searchData.from = monthAgoDate.toISOString().split('T')[0]
            this.searchData.to = currentDate.toISOString().split('T')[0];
        },
        /********************************/
        /* */
        async fetchOptions() {
            if (this.getDeparts.length == 0) {
                await this.fetchDeparts();
            }
            if (this.getUser.hasOwnProperty("empNo") == 0) {
                await this.fetchUser();
            }
            // this.departs = (this.getDeparts[0].id == 1) ? this.getDeparts.slice(1) : this.getDeparts;
            this.departs = this.getDeparts;
        },
        /********************/

        // Fetch the report data with pagination for each section
        async getReport() {
            this.searchData.pageNo = 1;
            try {
                const response = await this.$axios.post(`api/employee/report/getuseracivities`, this.searchData);

                if (response?.data && response?.data.isSuccess) {
                    // Update the reportData with pagination information for each section
                    this.reportData = [response.data.data];
                } else {
                    this.$tempAlert(response?.data.msg ?? "حدثت مشكلة", 'warning');
                    this.reportData = [];
                }
            } catch (error) {
                console.error("Error fetching report:", error);
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
            }
        },

        // Change the current page for a specific report section
        changePage(reportAppSection, newPageNo) {
            if (newPageNo >= 1 && newPageNo <= reportAppSection.totalPages) {
                reportAppSection.pageNo = newPageNo;
                this.getReportForSection(reportAppSection);
            }
        },

        /********************/
        // Fetch the report for a specific section based on the page number
        async getReportForSection(reportAppSection) {
            this.searchData.pageNo = reportAppSection.pageNo
            try {
                const response = await this.$axios.post(`api/employee/report/getuseracivities`, this.searchData);
                this.reportData = [response.data.data];
            } catch (error) {
                console.error("Error fetching report for section:", error);
            }
        },
        /********************/
        /* */
        resetValues() {
            this.reportData=[];
            this.searchData.pageNo = 1;
        },
        /********************/
        /** Fetch the report as a pdf file */
        async printPdf() {
            this.searchData.pageNo = 1;
            try {
                const response = await this.$axios.post( 'api/employee/report/getuseracivities/print', this.searchData,
                    {
                        responseType: 'blob',
                    });

                console.log(response)

                const blob = new Blob([response.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob)

                // Open in a new tab
                window.open(url, '_blank')

                // Optional cleanup (after some delay to let the file load)
                setTimeout(() => {
                    window.URL.revokeObjectURL(url)
                }, 100)
            } catch (error) {
                console.error("Error fetching report:", error);
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
            }
        },
    }
}
</script>
